import useGraphClient from './useGraphClient';

type CreatePublicOneDriveLinkResponse = {
  link: {
    webUrl: string;
  };
};

const useGetOneDriveFilePublicUrl = () => {
  const graphClient = useGraphClient();

  const getOneDriveFilePublicUrl = async (fileId: string): Promise<string> => {
    // Note that if a public url already exists, the OneDrive API will simply
    // reuse that URL
    const linkResponse: CreatePublicOneDriveLinkResponse = await graphClient
      .api(`/me/drive/items/${fileId}/createLink`)
      .post({
        type: 'view',
        scope: 'anonymous',
      });

    return linkResponse.link.webUrl;
  };

  return getOneDriveFilePublicUrl;
};

export default useGetOneDriveFilePublicUrl;
